import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { kioscoUpd } from "services/services-mia/miakey";
const customRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s:\-\\/\\.]+$/;

export default function UpdateModal({ updateList, kiosco, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async ({
        identificacion
    }) => {
        setInRequest(true);

        const response = await kioscoUpd({
            gateDeviceId: kiosco.gateDeviceId,
            gateDeviceIdentificacion: identificacion,
            gateDeviceVersion: kiosco.gateDeviceVersion
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "Kiosco modificado exitosamente",
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                identificacion: kiosco.gateDeviceIdentificacion ?? "",
            }}
            validationSchema={
                yup.object({
                    identificacion: yup.string(FORM_ERROR_MESSAGES.text)
                        .min(2, "Debe tener minimo 2 caracteres")
                        .max(45, "Debe tener un maximo de 45 caracteres")
                        .matches(
                            customRegex,
                            "Debe tener solo letras y/o números"
                        )
                        .required(FORM_ERROR_MESSAGES.required)
                })
            }
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="identificacion"
                        labelText={"Identificación"}
                        placeholder="Ingrese identificación"
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar cambios" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
